import { useMemo } from 'react'

import { BuilderMenu, BuilderMenuItem } from '@makyoapp/makyo-common'

import { Accordion } from '@/components/Accordion/Accordion'

import MenuItemActionAccordion from './MenuItem/MenuItemActionAccordion'
import MenuItemBadgeAccordion from './MenuItem/MenuItemBadgeAccordion'
import MenuItemBehaviorAccordion from './MenuItem/MenuItemBehaviourAccordion'
import MenuItemSettingAccordion from './MenuItem/MenuItemSettingAccordion'

/**
 * MenuItemEditAccordion is a function component that provides an interface for editing a menu item in a builder.
 * It uses the useMemo hook to calculate the index of the menu item being edited.
 * It contains four accordion items: MenuItemSettingAccordion, MenuItemActionAccordion, MenuItemBehaviorAccordion, and MenuItemBadgeAccordion.
 * Each accordion item provides different settings for the menu item.
 */
function MenuItemEditAccordion({
  menu,
  menuIdx,
  menuItem: curMenuItem,
}: {
  menuIdx: number
  menu: BuilderMenu
  menuItem: BuilderMenuItem
}) {
  const menuItemIdx = useMemo(() => {
    // Calculate the index of the menu item being edited
    return menu.items.findIndex((m) => m.id === curMenuItem.id)
  }, [menu, curMenuItem.id])

  // The menu item editing interface
  return (
    <Accordion openMultiple={false} initialActiveItems={['menu-item-settings']}>
      <MenuItemSettingAccordion menu={menu} menuIdx={menuIdx} menuItemIdx={menuItemIdx} />
      <MenuItemActionAccordion menu={menu} menuIdx={menuIdx} menuItem={curMenuItem} menuItemIdx={menuItemIdx} />
      <MenuItemBehaviorAccordion menu={menu} menuIdx={menuIdx} menuItem={curMenuItem} menuItemIdx={menuItemIdx} />
      <MenuItemBadgeAccordion menu={menu} menuIdx={menuIdx} menuItemIdx={menuItemIdx} />
    </Accordion>
  )
}

export default MenuItemEditAccordion
